export const LEVEL_FLOW_TYPE = {
  SEQUENTIAL: 'sequential',
  PARALLEL: 'parallel',
};
